var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFa6SolidIdBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 61,
    viewBox: "0 0 47 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3362_5418)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.76025 0C3.47999 0 0 3.37389 0 7.52366V52.6656C0 56.8154 3.47999 60.1893 7.76025 60.1893H38.8013C43.0815 60.1893 46.5615 56.8154 46.5615 52.6656V7.52366C46.5615 3.37389 43.0815 0 38.8013 0H7.76025ZM19.4006 37.6183H27.1609C32.5203 37.6183 36.8612 41.8268 36.8612 47.0229C36.8612 48.0574 35.9882 48.9038 34.9211 48.9038H11.6404C10.5733 48.9038 9.70032 48.0574 9.70032 47.0229C9.70032 41.8268 14.0412 37.6183 19.4006 37.6183ZM15.5205 26.3328C15.5205 24.3374 16.3381 22.4237 17.7934 21.0128C19.2488 19.6018 21.2226 18.8091 23.2808 18.8091C25.3389 18.8091 27.3128 19.6018 28.7681 21.0128C30.2234 22.4237 31.041 24.3374 31.041 26.3328C31.041 28.3282 30.2234 30.2419 28.7681 31.6528C27.3128 33.0638 25.3389 33.8565 23.2808 33.8565C21.2226 33.8565 19.2488 33.0638 17.7934 31.6528C16.3381 30.2419 15.5205 28.3282 15.5205 26.3328ZM17.4606 7.52366H29.1009C30.168 7.52366 31.041 8.37007 31.041 9.40457C31.041 10.4391 30.168 11.2855 29.1009 11.2855H17.4606C16.3935 11.2855 15.5205 10.4391 15.5205 9.40457C15.5205 8.37007 16.3935 7.52366 17.4606 7.52366Z",
    fill: "#321E5D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3362_5418"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46.5615,
    height: 60.1893,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFa6SolidIdBadge);
export default __webpack_public_path__ + "static/media/fa6-solid_id-badge.fd03cc1a5ab1b41a2d6f90a3ebeb9113.svg";
export { ForwardRef as ReactComponent };